import { ArrowRight } from "lucide-react";
import { Glass } from "../Glass";
import { Words } from "../Words";

export const HeroCopy = ({ onPrimary, onSecondary }) => (
  <div className="mx-auto flex max-w-[820px] flex-col items-center px-5 pt-10 text-center sm:pt-12 lg:pt-6">
    <Glass variant="light" className="reveal mb-7 inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-[13px] font-semibold text-[#2b2e3d]">
      <span className="h-2 w-2 rounded-full bg-gradient-to-r from-[#7866E8] to-[#80D9EB]" aria-hidden />
      Introducing SOCIAL AI
    </Glass>
    <h1 className="h-hero will-reveal text-[#08090D]">
      <span className="block" data-testid="hero-title-line-1">
        <Words text="Making Social" />
      </span>
      <span className="block pb-2" data-testid="hero-title-line-2">
        <Words text="Interesting." start={2} className="text-gradient-hero" />
      </span>
    </h1>
    <p className="reveal mt-6 text-[19px] font-semibold leading-snug text-[#14151B] sm:text-[21px]" style={{ animationDelay: "0.25s" }} data-testid="hero-supporting">
      Stories spark conversations.
      <br />
      AI brings people closer.
    </p>
    <p className="reveal mt-4 max-w-[560px] text-[16px] leading-relaxed text-[#4c5064] sm:text-[17px]" style={{ animationDelay: "0.32s" }} data-testid="hero-secondary">
      A new social experience where every moment can become a conversation, every conversation can become a connection, and AI helps meaningful things happen.
    </p>
    <div className="reveal pointer-events-auto mt-9 flex flex-col items-center gap-3 sm:flex-row" style={{ animationDelay: "0.4s" }}>
      <button type="button" onClick={onPrimary} data-testid="hero-get-early-access-button" className="btn-primary h-14 px-8 text-[16px]">
        Get Early Access
        <ArrowRight size={18} aria-hidden />
      </button>
      <button type="button" onClick={onSecondary} data-testid="hero-explore-button" className="btn-glass glass glass-light h-14 px-8 text-[16px]">
        Explore the Experience
      </button>
    </div>
  </div>
);
